module.exports = __webpack_public_path__ + "static/media/freedial.7107dc1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/freedial.svg
// module id = 490
// module chunks = 11